import React from "react";

export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="mx-8 flex items-center font-display text-3xl sm:text-5xl font-light text-cream-50/80"
          >
            {item}
            <span className="mx-8 text-gold text-2xl">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
